export default {
    install(Vue) {
        Vue.mixin({
            data() {
                return {
                    delay: (function(){
                        let timer = 0;
                        return function(callback, ms){
                            clearTimeout(timer);
                            timer = setTimeout(callback, ms);
                        };
                    })()
                }
            },
            methods: {
                findItem(items, id, field) {
                    if (field === undefined) field = 'name';
                    let item = items.find(v => v.id === id);
                    return item !== undefined ? item[field] : null;
                },
                getPermission(permissionName) {

                    let item = this.$store.state.common.users.find(v => v.id === this.$store.state.common.userId);

                    if (item === undefined) return false;

                    for (let key in item.permissions) {

                        if (item.permissions[key] === permissionName) {
                            return true;
                        }
                    }

                    return false;
                }
            }
        })
    }
}